import { useCallback, useRef, useState } from 'react';
import { geocodeByAddress } from 'react-places-autocomplete';

export type IGoogleData = {
  city?: string;
  state?: string;
  zip?: string;
  street1?: string;
  street2?: string;
  county?: string;
};

export const getAddressObj = async (address: string) => {
  const results = await geocodeByAddress(address);
  const storableLocation = {} as IGoogleData;
  for (let ac = 0; ac < results[0].address_components.length; ac += 1) {
    const component = results[0].address_components[ac];
    if (
      component.types.includes('sublocality') ||
      component.types.includes('locality')
    ) {
      storableLocation.city = component.long_name;
    } else if (component.types.includes('administrative_area_level_1')) {
      storableLocation.state = component.long_name;
    } else if (component.types.includes('postal_code')) {
      storableLocation.zip = component.long_name;
    } else if (component.types.includes('street_number')) {
      storableLocation.street1 =
        component.long_name === undefined ? '' : component.long_name;
    } else if (component.types.includes('route')) {
      if (storableLocation.street1 !== undefined) {
        storableLocation.street1 += ` ${component.long_name}`;
      } else {
        storableLocation.street1 = component.long_name;
      }
    } else if (component.types.includes('neighborhood')) {
      storableLocation.street2 = component.long_name;
    } else if (component.types.includes('administrative_area_level_2')) {
      storableLocation.county = component.long_name;
    }
  }
  // const latLng = await getLatLng(results[0]);
  return storableLocation;
};

export const useGooglePlace = () => {
  const [input, setInput] = useState('');
  const [googleData, setGoogleData] = useState<
    IGoogleData & { full: string }
  >();
  const selOptions = useRef({
    componentRestrictions: {
      country: ['us'],
    },
    location: new window.google.maps.LatLng(25.761681, -80.191788),
    types: ['address'],
    radius: 100000,
  });
  const buyOptions = useRef({
    componentRestrictions: {
      country: ['us'],
    },
    location: new window.google.maps.LatLng(25.761681, -80.191788),
    radius: '10',
  });

  const hanldeChange = useCallback((address: string) => {
    setInput(address);
  }, []);

  const hanldeSelect = useCallback(async (address: string, placeID: string) => {
    if (placeID) {
      setInput(address);
      const obj = await getAddressObj(address);
      setGoogleData({
        ...obj,
        full: address,
      });
    }
  }, []);

  return {
    selOptions,
    buyOptions,
    input,
    googleData,
    hanldeChange,
    hanldeSelect,
    setGoogleData,
  };
};
